let loaded = false;

export const useComparisonList = () => {
  const MAX_ITEMS = 4
  const comparisonSet = useState('comparison-list', () => new Set())

  const saveToLocalStorage = () => {
    if (import.meta.client) {
      localStorage.setItem('comparison_list', JSON.stringify([...comparisonSet.value]))
    }
  }

  const loadFromLocalStorage = () => {
    if (import.meta.client && !loaded) {
      const saved = localStorage.getItem('comparison_list')
      comparisonSet.value = saved ? new Set(JSON.parse(saved)) : new Set()
      loaded = true
    }
  }

  const addToComparison = (uuid) => {
    if (comparisonSet.value.has(uuid)) return

    // Limit to 4 items → remove oldest if full
    if (comparisonSet.value.size >= MAX_ITEMS) {
      const oldest = comparisonSet.value.values().next().value
      comparisonSet.value.delete(oldest)
    }

    comparisonSet.value.add(uuid)
    saveToLocalStorage()
  }

  const removeFromComparison = (uuid) => {
    comparisonSet.value.delete(uuid)
    saveToLocalStorage()
  }

  const toggleComparison = (uuid) => {
    if (comparisonSet.value.has(uuid)) {
      removeFromComparison(uuid)
    } else {
      addToComparison(uuid)
    }
  }

  const clearComparison = () => {
    comparisonSet.value.clear()
    saveToLocalStorage()
  }

  const isInComparison = (uuid) => comparisonSet.value.has(uuid)
  const comparisonList = computed(() => Array.from(comparisonSet.value))
  const comparisonURL = computed(() => `/compare-vehicles?compare=${comparisonList.value.join(",")}`)

  onMounted(() => {
    loadFromLocalStorage()
  })

  if (import.meta.client) {
    window.addEventListener('storage', (event) => {
      if (event.key === 'comparison_list') {
        loadFromLocalStorage()
      }
    })
  }

  return {
    comparisonURL,
    comparisonList,
    addToComparison,
    removeFromComparison,
    toggleComparison,
    clearComparison,
    isInComparison,
  }
}
